import {
    $host,
    $authHost
} from './index';


export const fetchCalendar = async (
    addId,
    params = {}
) => {
    const {
        dateFrom,
        dateTo
    } = params;

    const { data } = await $authHost.get(
        `api/calendar/${addId}`,
        {
            params: {
                dateFrom: dateFrom || undefined,
                dateTo: dateTo || undefined
            }
        }
    );

    return data;
};


export const createCalendarPeriod = async (
    addId,
    payload
) => {
    const { data } = await $authHost.post(
        `api/calendar/${addId}/periods`,
        payload
    );

    return data;
};


export const updateCalendarPeriod = async (
    addId,
    periodId,
    payload
) => {
    const { data } = await $authHost.patch(
        `api/calendar/${addId}/periods/${periodId}`,
        payload
    );

    return data;
};


export const deleteCalendarPeriod = async (
    addId,
    periodId
) => {
    await $authHost.delete(
        `api/calendar/${addId}/periods/${periodId}`
    );
};

export const fetchCalendarPrices = async (
    addId,
    params = {}
) => {
    const {
        dateFrom,
        dateTo
    } = params;

    const { data } = await $authHost.get(
        `api/calendar/${addId}/prices`,
        {
            params: {
                dateFrom,
                dateTo
            }
        }
    );

    return data;
};


export const saveCalendarDateRules = async (
    addId,
    payload
) => {
    const { data } = await $authHost.put(
        `api/calendar/${addId}/prices`,
        payload
    );

    return data;
};


/*
 * Возвращает только цену к базовой.
 * Время заезда и выезда остаётся.
 */
export const deleteCalendarPrices = async (
    addId,
    params = {}
) => {
    const {
        dateStart,
        dateEnd
    } = params;

    const { data } = await $authHost.delete(
        `api/calendar/${addId}/prices`,
        {
            params: {
                dateStart,
                dateEnd
            }
        }
    );

    return data;
};

export const fetchCalendarConnections = async (
    addId
) => {
    const { data } = await $authHost.get(
        `api/calendar/${addId}/connections`
    );

    return data;
};


export const createCalendarConnection = async (
    addId,
    payload
) => {
    const { data } = await $authHost.post(
        `api/calendar/${addId}/connections`,
        payload
    );

    return data;
};


export const updateCalendarConnection = async (
    addId,
    connectionId,
    payload
) => {
    const { data } = await $authHost.patch(
        `api/calendar/${addId}/connections/${connectionId}`,
        payload
    );

    return data;
};


export const deleteCalendarConnection = async (
    addId,
    connectionId
) => {
    await $authHost.delete(
        `api/calendar/${addId}/connections/${connectionId}`
    );
};


export const syncCalendarConnection = async (
    addId,
    connectionId
) => {
    const { data } = await $authHost.post(
        `api/calendar/${addId}/connections/${connectionId}/sync`
    );

    return data;
};


export const initializeAvitoCalendarData = async (
    addId,
    payload
) => {
    const { data } = await $authHost.post(
        `api/calendar/${addId}/avito/initialize-calendar-data`,
        payload
    );

    return data;
};

export const getCalendarExportUrl = (
    exportPath
) => {
    if (!exportPath) {
        return '';
    }

    if (
        exportPath.startsWith('http://') ||
        exportPath.startsWith('https://')
    ) {
        return exportPath;
    }

    const apiUrl = String(
        process.env.REACT_APP_API_URL || ''
    ).replace(/\/+$/, '');

    const normalizedPath =
        String(exportPath).startsWith('/')
            ? exportPath
            : `/${exportPath}`;

    return `${apiUrl}${normalizedPath}`;
};

export const fetchCalendarSettings = async (
    addId
) => {
    const { data } = await $authHost.get(
        `api/calendar/${addId}/settings`
    );

    return data;
};


export const updateCalendarSettings = async (
    addId,
    payload
) => {
    const { data } = await $authHost.put(
        `api/calendar/${addId}/settings`,
        payload
    );

    return data;
};

export const fetchPublicCalendarAvailability = async (
    addId,
    params = {}
) => {
    const {
        dateFrom,
        dateTo
    } = params;

    const { data } = await $host.get(
        `api/calendar/${addId}/availability`,
        {
            params: {
                dateFrom,
                dateTo
            }
        }
    );

    return data;
};

export const saveCalendarRange = async (
    addId,
    payload
) => {
    const { data } =
        await $authHost.put(
            `api/calendar/${addId}/range`,
            payload
        );

    return data;
};

export const requestCalendarConnectionHelp = async (
    addId,
    payload = {}
) => {
    const { data } = await $authHost.post(
        `api/calendar/${addId}/help-request`,
        payload
    );

    return data;
};


export const createCalendarIntegrationInterest = async (
    addId,
    payload
) => {
    const { data } = await $authHost.post(
        `api/calendar/${addId}/integration-interest`,
        payload
    );

    return data;
};


export const fetchCalendarIntegrationInterests = async (
    addId
) => {
    const { data } = await $authHost.get(
        `api/calendar/${addId}/integration-interests`
    );

    return data;
};


export const fetchAdminCalendarConnections = async (
    params = {}
) => {
    const { data } = await $authHost.get(
        'api/calendar/admin/connections',
        {
            params
        }
    );

    return data;
};


export const fetchAdminCalendarIntegrationInterests = async (
    params = {}
) => {
    const { data } = await $authHost.get(
        'api/calendar/admin/integration-interests',
        {
            params
        }
    );

    return data;
};

export const upsertAdminAvitoIcalConnection = async (
    addId,
    avitoUrlOrId
) => {
    const { data } = await $authHost.put(
        `api/calendar/admin/adds/${addId}/avito-ical`,
        {
            avitoUrlOrId
        }
    );

    return data;
};


export const deleteAdminAvitoIcalConnection = async (
    addId
) => {
    const { data } = await $authHost.delete(
        `api/calendar/admin/adds/${addId}/avito-ical`
    );

    return data;
};
